import React from 'react';
import { NavLink } from 'react-router-dom';

const teamMembers = [
    {
        image: require('./../../images/our-team4/pic1.png'),
        membername: 'A SUHAS M(MD)',
        position: 'Architect and Designer',
        qualification: 'GD Arch, Master Of Engineering(Town and Country Planning)',
        experience: '32 years'
    },
    {
        image: require('./../../images/our-team4/pic2.png'),
        membername: 'RAMESH NAYAK(MD)',
        position: 'Planning Execution',
        qualification: 'BE Engineering(Electro Mechanical)',
        experience: '25 years'
    },
    {
        image: require('./../../images/our-team4/pic3.png'),
        membername: 'RASHMITA NAYAK(MD)',
        position: 'Marketing and Quality',
        qualification: 'D Engineering(Quality Management)',
        experience: '15 years'
    },
    {
        image: require('./../../images/our-team4/pic3.png'),
        membername: 'RAJLAXMI NAYAK',
        position: 'Technical Director-Mechanical',
        qualification: 'Principal Engineer Electrical',
        experience: '10 years'
    }
]

class Team3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Team</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE Team START */}
                        <div className="section-content">
                            <div className="row">
                                {teamMembers.map((item, index) => (
                                    <div key={index} className="col-md-3 col-sm-5 col-xs-5 col-xs-80pc m-b-10" >
                                        <div className="our-team-1 hover-animation-1 " style={{height:"400px"}}>
                                            <div className="profile-image scale-in-center"><img src={item.image} alt="" /></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5>{item.position}</h5>                       
                                                <h6>{item.qualification}</h6>
                                                <h6>{item.experience}</h6>
                                                <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} ><i className="fa fa-rss" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-youtube" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                               
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Team3;